import React, { useEffect } from 'react';
import ColumnChooser from '../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetBulkPriceSchemeListRequest } from '../../../../models/request/bulkPrice/BulkPriceRequests';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetBulkPriceSchemeListRequest
    setFilter: React.Dispatch<React.SetStateAction<GetBulkPriceSchemeListRequest>>
    selectedCount: number
    showDetail: () => void
}

const BulkPriceListFilters = ({
    columns, setColumns, getColumns, pageName, pageVersion,
    excelExport, filter, setFilter, selectedCount, showDetail
}: Props) => {
    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            {/* Bu ekranda kayıt açılmaz, güncellenmez, silinmez: yalnız detay gösterilir. */}
            <div className='m-0 me-2'>
                <a
                    onClick={selectedCount > 0 ? showDetail : undefined}
                    style={{ opacity: selectedCount > 0 ? 1 : 0.5, cursor: selectedCount > 0 ? 'pointer' : 'default' }}
                    className='btn btn-sm fw-bold btn-primary'
                    title={selectedCount > 0 ? undefined : 'Önce en az bir şablon seçin.'}
                >
                    Detay Göster{selectedCount > 0 ? ' (' + selectedCount + ')' : ''}
                </a>
            </div>

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />
        </React.Fragment>
    )
}

export default BulkPriceListFilters;
